<h2 mat-dialog-title>Filter by Level</h2>
<mat-dialog-content>
    <mat-selection-list [multiple]="false">
        <mat-list-option *ngFor="let info of filterLevels" [value]="info" (click)="close(info)">
            {{info.name}}
        </mat-list-option>
    </mat-selection-list>
</mat-dialog-content>